'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserPrefix = getBrowserPrefix;
exports.getHiddenNamespace = getHiddenNamespace;
exports.getVisibilityChangeNamespace = getVisibilityChangeNamespace;
exports.isHidden = isHidden;
exports.wrapVisibilityCallback = wrapVisibilityCallback;
exports.addVisibilityChangeListener = addVisibilityChangeListener;
exports.removeVisibilityChangeListener = removeVisibilityChangeListener;
function getBrowserPrefix() {
  var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  var doc = global.document;
  var browserPrefixes = ['', 'webkit', 'moz', 'ms', 'o'];

  for (var i = 0; i < browserPrefixes.length; i++) {
    var prefix = browserPrefixes[i];
    var withPrefix = prefix ? prefix + 'Hidden' : 'hidden';
    if (typeof doc[withPrefix] !== 'undefined') {
      return prefix;
    }
  }

  return null;
}

function getHiddenNamespace(prefix) {
  var withPrefix = prefix ? prefix + 'Hidden' : 'hidden';
  return withPrefix;
}

function getVisibilityChangeNamespace(prefix) {
  return prefix + 'visibilitychange';
}

function isHidden() {
  var prefix = getBrowserPrefix();
  if (prefix) {
    var hidden = getHiddenNamespace(prefix);
    return document[hidden];
  }

  if (typeof document.hasFocus === 'function') {
    return !document.hasFocus();
  }

  return false;
}

function wrapVisibilityCallback(callback) {
  return function (_ref) {
    var _ref$hidden = _ref.hidden,
        hidden = _ref$hidden === undefined ? isHidden() : _ref$hidden;

    callback({ isVisible: !hidden });
  };
}

function addVisibilityChangeListener(callback) {
  var prefix = getBrowserPrefix();
  if (prefix) {
    var visibilityChage = getVisibilityChangeNamespace(prefix);
    document.addEventListener(visibilityChage, wrapVisibilityCallback(callback));
  } else {
    window.addEventListener('focus', wrapVisibilityCallback(callback));
    window.addEventListener('blur', wrapVisibilityCallback(callback));
  }
}

function removeVisibilityChangeListener(callback) {
  var prefix = getBrowserPrefix();
  if (prefix) {
    var visibilityChage = getVisibilityChangeNamespace(prefix);
    document.removeEventListener(visibilityChage, wrapVisibilityCallback(callback));
  } else {
    window.removeEventListener('focus', wrapVisibilityCallback(callback));
    window.removeEventListener('blur', wrapVisibilityCallback(callback));
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.4519/js/visibility.js
// module id = 934
// module chunks = 2 3